<template>
  <AppNavbar />
  <div class="d-flex flex-column reports-layout">
    <AppHeader title="Reportes" class="header-compact px-4 border-bottom" />
    <div class="d-flex flex-grow-1">
      <aside class="sidebar p-3">
        <ul class="nav flex-column gap-1">
          <li v-for="item in menu" :key="item.name" class="nav-item">
            <router-link class="nav-link" :to="item.to" exact-active-class="active">
              <i :class="item.icon + ' me-2'"></i>{{ item.label }}
            </router-link>
          </li>
        </ul>
      </aside>
      <main class="flex-fill p-4">
        <router-view />
      </main>
    </div>
  </div>
</template>

<script>
import AppHeader from '@/components/AppHeader.vue'
import AppNavbar from '@/components/AppNavbar.vue'

export default {
  name: 'ReportesLayout',
  components: { AppHeader, AppNavbar },
  data() {
    return {
      menu: [
        { name: 'reportes-home', label: 'Resumen', to: { name: 'ReportesHome' }, icon: 'bi bi-grid-1x2' },
        { name: 'reportes-ventas', label: 'Ventas', to: { name: 'ReportesVentas' }, icon: 'bi bi-cash-coin' },
        { name: 'reportes-cierres-caja', label: 'Cierres de caja', to: { name: 'ReportesCierresCaja' }, icon: 'bi bi-safe2' },
        { name: 'reportes-productos', label: 'Productos vendidos', to: { name: 'ReportesProductosVendidos' }, icon: 'bi bi-box-seam' },
        { name: 'reportes-cuentas-cobrar', label: 'Cuentas por cobrar', to: { name: 'ReportesCuentasPorCobrar' }, icon: 'bi bi-wallet2' },
        { name: 'reportes-compras', label: 'Compras por proveedor', to: { name: 'ReportesComprasProveedor' }, icon: 'bi bi-truck' },
      ],
    }
  },
}
</script>

<style scoped>
.reports-layout {
  min-height: 100vh;
}

.header-compact {
  padding-top: .5rem;
  padding-bottom: .5rem;
}

.sidebar {
  width: 260px;
  background: #fff;
  border-right: 1px solid #e5e5e5;
}

.sidebar .nav-link {
  color: #111;
  border-radius: .25rem;
  padding: .6rem .9rem;
}

.sidebar .nav-link:hover {
  background: #f2f2f2;
  color: #111;
}

.sidebar .nav-link.active {
  background: #111;
  color: #fff;
  font-weight: 600;
}

main {
  background: #f9f9f9;
  overflow-y: auto;
}
</style>
